'use strict';

/**
 * "toggleHeight after timeout"
 */
function makeTall() {
    var $slideout = $('#account-slideout');
    $slideout.removeClass('hidden');

    // Allow time for DOM to register visibility before triggering animation
    setTimeout(function () {
        $slideout.addClass('active');
    }, 10);
}

module.exports = {
    accountSlideMenu: function () {
        $(document).ready(function () {
            var $accountIcon = $('#account-icon');
            var $slideout = $('#account-slideout');
            var $closeBtn = $slideout.find('.close-slideout');

            $accountIcon.hoverIntent(makeTall);
            $accountIcon.on('click', function () {
                $slideout.removeClass('hidden');

                // Allow time for DOM to register visibility before triggering animation
                setTimeout(function () {
                    $slideout.addClass('active');
                }, 10);
            });

            $closeBtn.on('click', function () {
                $slideout.removeClass('active');

                // Wait for transition to finish before hiding
                setTimeout(function () {
                    $slideout.addClass('hidden');
                }, 300); // Must match CSS transition duration
            });

            // Close on clicking outside
            $(document).on('mousedown touchstart', function (e) {
                if (
                    $slideout.hasClass('active') &&                        // Only when open
                    !$slideout.is(e.target) &&                             // Click target isn't the panel
                    $slideout.has(e.target).length === 0 &&                // Click target isn't inside the panel
                    !$accountIcon.is(e.target) &&                        // Click target isn't the icon
                    $accountIcon.has(e.target).length === 0              // Click target isn't inside the icon
                ) {
                    $slideout.removeClass('active');
                    setTimeout(function () {
                        $slideout.addClass('hidden');
                    }, 300); // Match your transition duration
                }
            });

            if ($('body').find('.login-page').length > 0) {
                $('.signup-btn').on('click', function () {
                    if (!($('#register-section').hasClass('active'))) {
                        $('#login-section').removeClass('active');
                        $('#register-section').addClass('active');
                    }
                });
            }
        });
    }
};
